import { LoginFieldSet } from "../login/loginFieldSet";
import React, { FunctionComponent } from "react";
import { FormType, withForm } from "../common/ui-form";
import { getInistitutionLoginFormValidations } from "./instituteLoginValidations";
import { getInstitueLoginControlState } from "./instituteLoginControlState";
import { CommonConstants } from "../common/constants/common-constants";
import { UIConfigurationContext } from "../common/contexts/ui-configurationContext";
import { IUserLoginInfo } from "./instituteLoginModels";
const InistitutionLoginForm = withForm<
    IUserLoginInfo,
    FormType<IUserLoginInfo>
>(LoginFieldSet);

export const InstituteLogin: FunctionComponent = () => {
    const uiConfigData = React.useContext(UIConfigurationContext);

    const intialValues = (): IUserLoginInfo => {
        return {
            userName: "",
            passWord: ""
        };
    };

    return (
        <InistitutionLoginForm
            enableReintialize
            formValues={intialValues()}
            getValidationSchema={(v: IUserLoginInfo) =>
                getInistitutionLoginFormValidations(v)
            }
            getControlState={(v: IUserLoginInfo) =>
                getInstitueLoginControlState(v)
            }
        />
    );
};